import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import TransfusionComponentsStep0Component from "./components/transfusion-components-step0/transfusion-components-step0";
import TransfusionComponentsStep0Part1 from "./components/transfusion-components-step0/transfusion-components-step0-parts/transfusion-components-step0-part1";
import TransfusionComponentsStep1Component from "./components/transfusion-components-step1/transfusion-components-step1";
import TransfusionComponentsStep1Part1 from "./components/transfusion-components-step1/transfusion-components-step1-parts/transfusion-components-step1-part1";
import TransfusionComponentsStep2Component from "./components/transfusion-components-step2/transfusion-components-step2";
import TransfusionComponentsStep2Part1 from "./components/transfusion-components-step2/transfusion-components-step2-parts/transfusion-components-step2-part1";

class Scenario7TransfusionVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 7 Transfusion';
    }
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 7 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario07/sc07-cinematic/cin-sc-7.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario07/sc07-mentor/mntr-sc-07.mp4', // change this
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario07/sc07-mentor/mntr-sc-07.mp4', // change this
				chapterIds: [
					'scenario7-5', //question 1 correct - don't delete comment!
					'scenario7-3', //question 1 incorrect - don't delete comment!
					'scenario7-4', //question 1 other option - don't delete comment!
					'scenario7-9',//question 2 correct - don't delete comment!
					'scenario7-7', //question 2 incorrect - don't delete comment!
					'scenario7-8', //question 2 other option - don't delete comment!
					'scenario7-13', //question 3 correct - don't delete comment!
					'scenario7-12', //question 3 incorrect - don't delete comment!
					'scenario7-16', //question 4 correct - don't delete comment!
					'scenario7-17', //question 4 incorrect - don't delete comment!
					'scenario7-18', //question 4 other option - don't delete comment!
					'scenario7-21', //question 5 correct - don't delete comment!
					'scenario7-20', //question 5 incorrect - don't delete comment!
					'scenario7-1', //scenario info 
					'scenario7-22' //scenario review
				]
			}
		];
	}
}

export const scenario7TransfusionVideoSegments = new Scenario7TransfusionVideoSegments();

class Scenario7TransfusionAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-07/mentor/jcdst-mentor-vo-scn-07-04.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-07/mentor/jcdst-mentor-vo-scn-07-09.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-07/mentor/jcdst-mentor-vo-scn-07-15.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-07/mentor/jcdst-mentor-vo-scn-07-19.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-07/mentor/jcdst-mentor-vo-scn-07-24.mp3'
			}
		];
	}
}

export const scenario7TransfusionAudioCaching = new Scenario7TransfusionAudioCaching();

export default class Scenario7Transfusion extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;
	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario7TransfusionVideoSegments.getItemByKey('MixedMedia'),
			scenario7TransfusionVideoSegments.getItemByKey('Feedback'),
		] 
	}
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario7Transfusion,
			title: 'Transfusion',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				Blood transfusion error: Transfusion was started on the wrong patient then was transferred to the correct 
				patient without reporting or changing the blood bag or IV set up. The nurse manager was notified by the nurse 
				aide the following afternoon. Physicians were notified. Both patients were monitored closely, with no 
				adverse effects noted.
				</p>
			`,
			mentorVideoUrl: scenario7TransfusionVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario7TransfusionVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }
	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as TransfusionComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as TransfusionComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as TransfusionComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as TransfusionComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as TransfusionComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as TransfusionComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as TransfusionComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;
	public scenarioId(): PageType {
		return PageType.Scenario7Transfusion;
    }

	private video: SingleVideoSegmentItem = scenario7TransfusionVideoSegments.getItemByKey('Scenario 7 Video 1');
	public getScenarioVideoURL(): string {
		return this.video.src;
	}
	public introScreenInfo(): IntroScreenUIConfig {
		return {
			title: 'Transfusion',
			subtitle: 'Incident Report',
			name: 'Becky',
			position: 'Nurse',
			time: 'Night Shift',
			place: 'In the patients’ room on a Med/Surg patient care unit',
			desc: `Blood transfusion error: Transfusion started on wrong patient then transferred to correct patient without reporting 
			or changing blood or IV set up. Nurse manager notified by the nurse aide the following afternoon. Physicians 
			notified. Both patients monitored closely, with no adverse effects noted.`,
			repeat: 'No',
			okButton: 'Continue'
		}
	}

	private step0Component = new TransfusionComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new TransfusionComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new TransfusionComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}